export const analyticsVisualMessages = {
  dailyClicks: 'Daily Clicks',
  trafficTrend: 'Traffic Trend',
  trafficTrendTimezone: 'Daily boundary: {offset}',
  chartType: 'Chart type',
  lineChart: 'Line chart',
  areaChart: 'Area chart',
  stackedBars: 'Stacked bars',
  totalSeries: 'Total',
  humanSeries: 'Human',
  uniqueSeries: 'Unique',
  botSeries: 'Bots',
  geographyTitle: 'Global Traffic',
  geographySubtitle: 'Visits by country or region',
  trafficIntensity: 'Traffic intensity',
  unmappedVisits: 'Unmapped',
  topRegions: 'Top regions',
  audienceComposition: 'Audience Composition',
  deviceMix: 'Device mix',
  browserMix: 'Browser mix',
  noVisitsRange: 'No visits in this range.',
} as const;
